import {
  BriefcaseBusiness,
  ClipboardCheck,
  Home,
  PackageCheck,
  ShieldAlert,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

export type UseCase = {
  id: string;
  icon: LucideIcon;
  titleKey: string;
  textKey: string;
};

export const useCases: UseCase[] = [
  {
    id: 'rental',
    icon: Home,
    titleKey: 'useCases.rental.title',
    textKey: 'useCases.rental.text',
  },
  {
    id: 'delivery',
    icon: PackageCheck,
    titleKey: 'useCases.delivery.title',
    textKey: 'useCases.delivery.text',
  },
  {
    id: 'insurance',
    icon: ShieldAlert,
    titleKey: 'useCases.insurance.title',
    textKey: 'useCases.insurance.text',
  },
  {
    id: 'repair',
    icon: Wrench,
    titleKey: 'useCases.repair.title',
    textKey: 'useCases.repair.text',
  },
  {
    id: 'inventory',
    icon: BriefcaseBusiness,
    titleKey: 'useCases.inventory.title',
    textKey: 'useCases.inventory.text',
  },
  {
    id: 'reports',
    icon: ClipboardCheck,
    titleKey: 'useCases.reports.title',
    textKey: 'useCases.reports.text',
  },
];
